/* NOTIFICATION */
const actionTypes = Object.freeze({
    CLEAR_STATE: 'NOTIFICATIONS/CLEAR_STATE',

    GET_NOTIFICATIONS: 'NOTIFICATIONS/GET_NOTIFICATIONS',
    GET_NOTIFICATIONS_SUCCESS: 'NOTIFICATIONS/GET_NOTIFICATIONS_SUCCESS',
    GET_NOTIFICATIONS_FAILED: 'NOTIFICATIONS/GET_NOTIFICATIONS_FAILED',

    GET_NOTIFICATIONS_UNREAD: 'NOTIFICATIONS/GET_NOTIFICATIONS_UNREAD',
    GET_NOTIFICATIONS_UNREAD_SUCCESS: 'NOTIFICATIONS/GET_NOTIFICATIONS_UNREAD_SUCCESS',
    GET_NOTIFICATIONS_UNREAD_FAILED: 'NOTIFICATIONS/GET_NOTIFICATIONS_UNREAD_FAILED',

    PATCH_NOTIFICATION: 'NOTIFICATIONS/PATCH_NOTIFICATION',
    PATCH_NOTIFICATION_SUCCESS: 'NOTIFICATIONS/PATCH_NOTIFICATION_SUCCESS',
    PATCH_NOTIFICATION_FAILED: 'NOTIFICATIONS/PATCH_NOTIFICATION_FAILED',

    GET_PREFERENCES: 'NOTIFICATIONS/GET_PREFERENCES',
    GET_PREFERENCES_SUCCESS: 'NOTIFICATIONS/GET_PREFERENCES_SUCCESS',
    GET_PREFERENCES_FAILED: 'NOTIFICATIONS/GET_PREFERENCES_FAILED',

    PUT_PREFERENCES: 'NOTIFICATIONS/PUT_PREFERENCES',
    PUT_PREFERENCES_SUCCESS: 'NOTIFICATIONS/PUT_PREFERENCES_SUCCESS',
    PUT_PREFERENCES_FAILED: 'NOTIFICATIONS/PUT_PREFERENCES_FAILED',

    MARK_ALL_READ: 'NOTIFICATIONS/MARK_ALL_READ',
    MARK_ALL_READ_SUCCESS: 'NOTIFICATIONS/MARK_ALL_READ_SUCCESS',
    MARK_ALL_READ_FAILED: 'NOTIFICATIONS/MARK_ALL_READ_FAILED',

    DISMISS_NOTIFICATION: 'NOTIFICATIONS/DISMISS_NOTIFICATION',
    DISMISS_NOTIFICATION_SUCCESS: 'NOTIFICATIONS/DISMISS_NOTIFICATION_SUCCESS',
    DISMISS_NOTIFICATION_FAILED: 'NOTIFICATIONS/DISMISS_NOTIFICATION_FAILED',
});

export default actionTypes;